<template>
  <!---合同标准--->
  <el-radio-group v-model="contractStandCode">
    <el-radio :label="item.dictCode" v-for="(item,index) in contractStandList" :key="index">{{item.dictName}}</el-radio>
  </el-radio-group>
  <!-------------->
</template>

<script>
  import {getListByTypeCodeAndPCode} from '@/api/dict/dic_manage'

  export default {
    name: "select-contractStand",
    data() {
      return {
        contractStandList: [],
        contractStandCode: ''
      }
    },
    created() {
      let data = {
        dictTypeCode: 'CONTRACT_STAND',
        parentCode: -1,
      }
      getListByTypeCodeAndPCode(data).then(res => {
        if (res.code == 1) {
          this.contractStandList = res.data
        }
      })
    },
    watch: {
      contractStandCode: function (currentVal) {
        this.$emit('contractStandInfo', {contractStandCode: currentVal})
      }
    }
  }
</script>

<style scoped>

</style>
